var __TEMP__ = require('./_baseGetAllKeys.js');var baseGetAllKeys = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getSymbolsIn.js');var getSymbolsIn = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keysIn.js');var keysIn = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getAllKeysIn;
